<app-header></app-header>

<!-- Title -->
<div class="section-lg bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg');">
  <div class="bg-dark-07">
    <div class="container">
      <div class="row g-4">
        <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
          <h1 class="fw-black m-0 display-4">Blog Standard</h1>
          <h2 class="fw-thin uppercase">CREATIVE DIGITAL AGENCY SINCE 2004</h2>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</div>
<!-- end Title -->

<!-- Blogs section -->
<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-md-8"> 
        <div class="post mrb-20" *ngFor="let post of posts">
          <div class="post-img"><img class="img-responsive" src="{{post.image}}" alt="post-1"></div>
          <div class="post-info">
            <h1><a routerLink="/blog-grid">{{ post.title }}</a></h1>
            <h6 class="purple-color">{{ post.category }}</h6>
            <p>{{ post.time }}</p>
            <a class="readmore" routerLink="/blog-grid">Read More <i class="eicon bi bi-arrow-right-short"></i></a>
          </div>
        </div>
        
        <div class="blog-grid-video">
          <div class="post video-blog mrb-20">
            <div class="post-img"><img class="img-responsive" src="assets/images/blogs/post-04.jpg" alt="post-4">
              <a class="video-play lightbox-media-box button-circle button-circle-md button-circle-outline-dark button-circle-hover-slide" (click)="openPopup()"><i class="bi bi-play-fill"></i><i class="bi bi-play-fill"></i></a>
            </div>
            <div class="post-info">
              <h1><a routerLink="/blog-grid">They say that a picture is worth a thousand words</a></h1>
              <h6 class="pink-color">Events</h6>
              <p>7 hours ago</p>
              <a class="readmore" routerLink="/blog-grid">Read More <i class="eicon bi bi-arrow-right-short"></i></a>
            </div>
          </div>
        </div>

        <!-- Video Popup -->
        <div class="video-popup" *ngIf="isOpen">
            <div class="popup-inner">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                <button (click)="closePopup()" type="button" class="close-btn">
                    <i class='bi bi-x'></i>
                </button>
            </div>
        </div>

        <h1 class="comment-reply-title mrt-30">Comments({{ comments.length }})</h1>
        <ul class="comment-box">
          @for (comment of comments; track comment.author) {
            <li class="post-comment">
              <div class="comment-content">
                <a href="#" class="avatar"><img [src]="comment.avatar" alt="avatar"></a>
                <div class="post-body">
                  <div class="comment-header">
                    <div class="author-left">
                      <div class="author"><a href="#">{{ comment.author }}</a></div>
                      <div class="time-ago">{{ comment.time }}</div>
                    </div>
                    <span class="reply"><a href="#">Reply</a></span>
                  </div>
                  <div class="post-message"><p>{{ comment.message }}</p></div>
                </div>
              </div>

              @if (comment.replies.length > 0) {
                <ul class="reply-comment">
                  @for (reply of comment.replies; track reply.author) {
                    <li class="post-comment">
                      <div class="comment-content">
                        <a href="#" class="avatar"><img [src]="reply.avatar" alt="avatar"></a>
                        <div class="post-body">
                          <div class="comment-header">
                            <div class="author-left">
                              <div class="author"><a>{{ reply.author }}</a></div>
                              <div class="time-ago"><a>{{ reply.time }}</a></div>
                            </div>
                            <span class="reply"><a>Reply</a></span>
                          </div>
                          <div class="post-message"><p>{{ reply.message }}</p></div>
                        </div>
                      </div>
                    </li>
                  }
                </ul>
              }
            </li>
          }
        </ul>
        <div class="clearfix"></div>
        <h1 class="comment-reply-title mrt-30">Leave a Comment</h1>
        <form id="form-comments" class="comment-form">
          <div class="row">
            <div class="col-md-6 form-group">
              <input type="text" class="form-control" placeholder="Name">
            </div>
            <div class="col-md-6 form-group">
              <input type="email" class="form-control" placeholder="Email">
            </div>
          </div>
          <div class="form-group">
            <textarea class="form-control" placeholder="Comment" rows="5"></textarea>
          </div>
          <p class="text-center">
            <button type="submit" class="button btn-candy button-lg button-rounded">Post Comment</button>
          </p>
        </form>
      </div>
      <div class="col-md-4 right-col-rv">
        <div class="widget sidebar_widget">
          <form class="search-form">
            <input type="text" class="form-control" placeholder="Search">
            <button type="submit" class="bi bi-search search-submit"></button>
          </form>
        </div>

        <div class="widget sidebar_widget widget_archive">
          <h5 class="widget-title">Archive</h5>
          <ul>
            @for (item of archives; track item.month) {
              <li><a href="#"><span>{{ item.month }}</span><em>({{ item.count }})</em></a></li>
            }
          </ul>
        </div>

        <div class="widget sidebar_widget widget_categories">
          <h5 class="widget-title">Categories</h5>
          <ul>
            @for (cat of categories; track cat) {
              <li><a href="#">{{ cat }}</a></li>
            }
          </ul>
        </div>

        <div class="widget sidebar_widget widget_tag_cloud">
          <h5 class="widget-title">Popular Tags</h5>
          <div class="post-tags">
            @for (tag of tags; track tag) {
              <a href="#">{{ tag }}</a>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- end Blogs section -->

<footer class="footer footer-three">
  <div class="footer-main">
    <div class="container">
      <div class="row">
        <!-- ABOUT -->
        <div class="col-sm-6 col-md-3">
          <div class="widget widget-links">
            <h5 class="widget-title">About Us</h5>
            <div class="footer-about">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                In at purus varius odio tempus cursus. vitae, commodo dui.
              </p>
              <ul class="social-media">
                <li *ngFor="let social of socialLinks">
                  <a [href]="social.url" class="bi" [ngClass]="social.icon"></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- QUICK LINKS -->
        <div class="col-sm-6 col-md-2">
          <div class="widget widget-links">
            <h5 class="widget-title">Quick Links</h5>
            <ul>
              <li *ngFor="let link of quickLinks">
                <a [href]="link.url">{{link.name}}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- RECENT POSTS -->
        <div class="col-sm-6 col-md-4">
          <div class="widget widget-links">
            <h5 class="widget-title">Recent Post</h5>
            <div class="row post-sm-content" *ngFor="let post of recentPosts; let i=index" [class.mrt-20]="i > 0">
              <div class="col-md-3 col-sm-3 col-xs-3">
                <img class="img-overlay border-radius-100" [src]="post.image" alt="post">
              </div>
              <div class="col-md-9 col-sm-9 col-xs-9">
                <h6>{{post.title}}</h6>
                <p>{{post.desc}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- CONTACT -->
        <div class="col-sm-6 col-md-3">
          <div class="widget widget-text">
            <h5 class="widget-title">Contact Us</h5>
            <ul class="footer-contact">
              <li>
                <i class="bi bi-pin-fill"></i>
                <p>Schönhauser Allee 167c 10435 Berlin Germany</p>
              </li>
              <li>
                <i class="bi bi-envelope"></i>
                <p>
                  <a href="mailto:yoursite@gmail.com">
                    yoursite&#64;gmail.com
                  </a>
                </p>
              </li>
              <li>
                <i class="bi bi-phone-fill"></i>
                <p>+49 30 47373795</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- COPYRIGHT -->
  <div class="footer-copyright">

    <div class="container">

      <div class="row d-flex justify-content-center">
        <div class="col-md-2">

          <div class="logo-footer">
            <a routerLink="/">
              <img class="img-responsive" src="assets/images/logo-footer.png" alt="footer-logo">
            </a>
          </div>

        </div>
      </div>


      <div class="row">
        <div class="col-md-12">

          <div class="copy-right"> © Copyright 2026 Chaos. Designed By <a href="https://themeforest.net/user/designsninja/portfolio" target="_blank">
              DesignsNinja
            </a>
          </div>

        </div>
      </div>

    </div>

  </div>

</footer>